// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Z3w9t","colMin":"styles_colMin__AOuuj"};